<template lang="pug">
    div.text-xs-left
        .AddOther-title Producto {{slide.index}} - {{slide.product}}
        v-spacer.py-sm-3
        .AddOther-question.pb-5.pb-sm-0 ¿Quieres agregar otro producto relacionado con {{slide.product}}?
        v-spacer.py-3
        v-radio-group.AddOther-radios(v-model="addToPlan" @change="changeValue")
            v-radio(label="Si" :value="true")
            v-spacer.py-sm-2
            v-radio(label="No" :value="false")            
        viewPlanButton.AddOther-view-button
</template>

<script>
import { mapGetters } from 'vuex';
import viewPlanButton from '@/components/life-plan/view-plan-button/view-plan-button';

export default {
  name: 'AddOther',
  components:{
      viewPlanButton
  },
  computed: {
    ...mapGetters(['currentStep']),     
  },
  props: {
    slide: {
      type: Object,
      default: function () {
        return { }
      }
    }
  },
  data() {
      return {
          addToPlan: null
      }
  },
  methods: {
    changeValue(value) {
      this.$emit('addOtherAnswer', value);
    }
  }
}
</script>

<style scoped>
@import 'add-other.scss';
</style>

